import { useTranslation } from 'react-i18next';
import '../../styles/components/noAccess/noAccessNotice.scss';

/**
 * The friendly "no access" message for a page or tab the member's role may
 * not use. Shown instead of raw "forbidden" errors and toasts.
 */
const NoAccessNotice = () => {
  const { t } = useTranslation();
  return (
    <div className='noAccessNotice' role='status'>
      {t('PageNoPermission')}
    </div>
  );
};

export default NoAccessNotice;
